import {IPaywallFragmentFragment} from '~Api/Graphql/gql/types.generated';
import useSelectedRegion from './useSelectedRegion';
import { UmbTypeChecker } from '@src/Umbraco/Utils/UmbTypeChecker';

function useDefaultPaywall(): IPaywallFragmentFragment | undefined {
  const region = useSelectedRegion();
  
  return UmbTypeChecker.isPaywall(region?.defaultPaywall) ? region?.defaultPaywall : undefined;
}

export default useDefaultPaywall;
